module.exports = __webpack_public_path__ + "assets/images/chroma-animation_42e2e2f7268b1c26a82285611fcd3741.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/chroma-animation.gif
// module id = 252
// module chunks = 0